export enum FIRESTORE_COLLECTION {
    images = 'images',
    users = 'users',
    shopping_lists = 'shopping_lists',
    invitations = 'invitations',
}
